import React from 'react';
import { Grid, Button, Confirm, Segment } from 'semantic-ui-react';

const Buttons = ({ position, fn, data, modal, auth, grade, type, history }) => {
  let dom = null;
  if (position === 'top') {
    const status = grade && type !== 'dormant' ? grade.status : grade;
    let sIsDim = false;
    let wIsDim = false;
    if (grade) {
      if (status === 'INACTIVE') {
        sIsDim = true;
      }
      if (history) {
        history.forEach((item) => {
          const hType = item.type;
          const hStatus = item.status;
          if (status === 'INACTIVE' || (hType === 'INACTIVE' && hStatus === 'READY')) {
            sIsDim = true;
          }
          if (hType === 'WITHDRAW' && hStatus === 'READY') {
            wIsDim = true;
          }
        });
      }
    }

    dom = (
      <Grid className="det-form-btn">
        <Grid.Column floated="left" width={10}>
          <Button
            className="pwd-init-btn"
            inverted
            color="black"
            onClick={() => modal.onOff(true, 'small')}
          >
            비밀번호 초기화
          </Button>
          {type !== 'dormant' ? (
            <Button
              className="logout-btn"
              color="black"
              onClick={() => fn.confirmShow(true, 'logout')}
            >
              강제 로그아웃
            </Button>
          ) : null}
        </Grid.Column>
        <Grid.Column floated="right" textAlign="right" width={6}>
          {data.groupAuth.all || data.groupAuth.delete ? (
            <div>
              <Button
                color="red"
                className="resign-btn"
                disabled={sIsDim}
                inverted={!sIsDim}
                onClick={() => fn.accountModal(true, '계정 일시정지')}
              >
                계정 일시정지
              </Button>
              <Button
                color="red"
                className="resign-btn"
                disabled={wIsDim}
                inverted={!wIsDim}
                onClick={() => fn.accountModal(true, '계정 탈퇴')}
              >
                계정 탈퇴
              </Button>
            </div>
          ) : null}
          <Confirm
            open={data.confirmShow}
            cancelButton="취소"
            confirmButton={data.confirmText.btnText}
            header={data.confirmText.header}
            onCancel={() => fn.confirmShow(false)}
            onConfirm={fn.confirmFn}
            content={data.confirmText.text}
            className="confirm-model"
          />
        </Grid.Column>
        <Segment vertical />
      </Grid>
    );
  } else {
    dom = (
      <Grid className="form-btn">
        <Grid.Column floated="left" width={4}>
          {auth ? (
            <Button inverted color="black" onClick={fn.authChange}>
              {' '}
              권한 및 범위 변경하기{' '}
            </Button>
          ) : null}
        </Grid.Column>
        <Grid.Column textAlign="right" width={12}>
          <Button className="cancel" inverted color="grey" onClick={() => fn.movePage('close')}>
            취소
          </Button>
          {type !== 'dormant' ? (
            <Button className="ok" color="green" onClick={fn.staffInfoAct}>
              완료
            </Button>
          ) : null}
        </Grid.Column>
        <Segment vertical />
      </Grid>
    );
  }
  return dom;
};

export default Buttons;
